import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List } from 'antd'

import { isObjEmpty } from '@utils/index'

import ConfirmButton from '@components/ConfirmButton'

@inject((store: any) => {
    const { popupStore, rightParamSetStore } = store
    return { popupStore, rightParamSetStore }
})
@observer
export default class ParamGroupPopup extends Component<any, any> {
    state: any = {
        values: {},
        errors: {}
    }

    closePopup = () => {
        this.setState({ values: {}, errors: {} })
        this.props.popupStore.togglePopup(false)
        this.props.rightParamSetStore.resetEdit()
    }

    handleDeleteRightParamSet = async () => {
        const { popupStore, rightParamSetStore } = this.props
        await rightParamSetStore.deleteRightParamSet(popupStore.info.id)
        if (!isObjEmpty(rightParamSetStore.errors)) this.closePopup()
    }

    handleSubmitRightParamSet = async () => {
        const { popupStore, rightParamSetStore } = this.props
        if (popupStore.info.id) {
            await rightParamSetStore.updateRightParamSet(popupStore.info.id)
            if (!isObjEmpty(rightParamSetStore.errors)) this.closePopup()
        } else {
            await rightParamSetStore.addRightParamSet()
            if (!isObjEmpty(rightParamSetStore.errors)) this.closePopup()
        }
    }

    render() {
        const { popupType, info } = this.props.popupStore
        const { rightParamSetStore } = this.props
        let foundItems = ''
        let disableDelete = false
        if (info.__meta__) {
            const { related_policies, related_rights, related_parameters } = info.__meta__
            disableDelete = related_policies || related_rights || related_parameters
            foundItems =
                related_policies || related_rights || related_parameters
                    ? 'נמצאו פריטים המשוייכים לטבלה זו לכן לא ניתן להסיר אותה'
                    : ''
        }
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                {info.id && !disableDelete ? (
                    <ConfirmButton
                        confirmed={() => this.handleDeleteRightParamSet()}
                        confirmQuestion="למחוק טבלה?"
                        buttonText="מחק טבלה"
                    />
                ) : (
                    ''
                )}
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>ביטול</Button>
                    <Button
                        type="primary"
                        disabled={!isObjEmpty(rightParamSetStore.edit)}
                        onClick={() => this.handleSubmitRightParamSet()}
                    >
                        {info.id ? 'שמור טבלה' : 'הוסף טבלה'}
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={info.id ? 'עריכת טבלה' : 'הוספת טבלה'}
                visible={popupType === 'rightParamSet'}
                footer={footerButtons}
                onCancel={this.closePopup}
            >
                <div>
                    <label htmlFor="right_param_set_name">
                        <strong>שם טבלה</strong>
                    </label>
                    <Input
                        id="right_param_set_name"
                        value={'name' in rightParamSetStore.edit ? rightParamSetStore.edit.name : info.name}
                        placeholder="הזן את שם הטבלה"
                        onChange={e => rightParamSetStore.setValue('name', e.target.value)}
                    />
                    {rightParamSetStore.errors['serverError'] ? (
                        <div style={{ color: 'red' }}>{rightParamSetStore.errors['serverError']}</div>
                    ) : (
                        ''
                    )}
                    {rightParamSetStore.errors['name'] ? (
                        <div style={{ color: 'red' }}>{rightParamSetStore.errors['name']}</div>
                    ) : (
                        ''
                    )}
                    {foundItems ? <span style={{ fontWeight: 'bold' }}>* {foundItems}</span> : ''}
                </div>
            </Modal>
        )
    }
}
